import { Component } from '@angular/core';
import { MultiCheckboxModel } from 'src/app/Modelo/multiCheckboxModel';
import { CategoriaModel } from '../../Modelo/Categoria.model';
import { MarcaModel } from '../../Modelo/Marca.model';
import { SerieModel } from '../../Modelo/Serie.model';
import { TipoProductoModel } from '../../Modelo/TipoProducto.model';
import { CategoriasService } from '../../Servicios/categorias.service';
import { GlobalService } from '../../Servicios/global.service';
import { MarcasService } from '../../Servicios/marcas.service';
import { SeriesService } from '../../Servicios/series.service';
import { TiposDeProductosService } from '../../Servicios/tipos-de-productos.service';
import { UtilidadesService } from '../../utilidades/utilidades.servicios.index';
import { String } from '../../utilidades/Extensions/string-extensions';
import { appConstants } from '../../constants';
import { CategoriaPrincipalModel } from 'src/app/Modelo/CategoriaPrincipal.model';

@Component({
	selector: 'menu',
	templateUrl: './menu.component.html'
})
export class MenuComponent {
	public ListaCategoriasPrincipales: CategoriaPrincipalModel[] = [];
	public ListaCategorias: CategoriaModel[] = [];
	public ListaMarcas: MarcaModel[] = [];
	public ListaTiposDeProductos: TipoProductoModel[] = [];
	public ListaSort = [
		{ name: appConstants.sortNames.description, value: appConstants.sortingCategories.description },
		{ name: appConstants.sortNames.brand, value: appConstants.sortingCategories.brand },
		{ name: appConstants.sortNames.serie, value: appConstants.sortingCategories.serie },
		{ name: appConstants.sortNames.productType, value: appConstants.sortingCategories.productType }
	];

	get isFilteringByText(): boolean {
		return !String.isNullOrWhiteSpace(this.Global.FiltroProductos.TextoABuscar);
	}

	get multiCheckboxPanelLabel(): string {
		return `Buscar ${!String.isNullOrWhiteSpace(this.Global.FiltroProductos.TextoABuscar) 
			? ('"' + this.Global.FiltroProductos.TextoABuscar.slice(0, 20) + '"') : String.empty} por...`;
	}

	get textFilterCategories(): Array<MultiCheckboxModel<number>> {
		return this.Global.FiltroProductos.textFilterCategories;
	}

	get isSearching(): boolean {
		return this.Global.isSearching;
	}

	constructor(
		public Utilidades: UtilidadesService,
		public Categorias: CategoriasService,
		public Global: GlobalService,
		public Marcas: MarcasService,
		public Series: SeriesService,
		public TiposDeProductos: TiposDeProductosService
	) {
		this.Categorias.ListaPrincipal().subscribe(c => this.ListaCategoriasPrincipales = c);
		this.Categorias.Lista().subscribe(c => this.ListaCategorias = c);
		this.Marcas.Lista().subscribe(m => this.ListaMarcas = m);
		this.Series.Lista().subscribe(s => this.Global.ListaSeries = s);
		this.TiposDeProductos.Lista().subscribe(tp => this.ListaTiposDeProductos = tp);
		
		if ((this.Global.FiltroProductos.textFilterCategories?.length ?? 0) > 0)
			return;

		this.Global.FiltroProductos.loadTextFilterCategories(this.Global.FiltroProductos.TextFilterCategoryDescription);
	}

	onTextFiltersChanged(selectedFilters: Array<MultiCheckboxModel<number>>): void {
		if ((selectedFilters?.length ?? 0) > 0) {
			this.Global.FiltroProductos.textFilterCategories.forEach((currentMulticheckbox: MultiCheckboxModel<number>) => {
				if (selectedFilters.includes(currentMulticheckbox))
					currentMulticheckbox.checked = true;
			})
		}
		
		this.Global.FiltroProductos._textFilterCategoriesChange.emit();
	}

	onBrandSelected(brandSelectedEvent: MarcaModel): void {
		if (brandSelectedEvent === null || brandSelectedEvent === undefined)
			return;

		this.Global.FiltroProductos.Marca = brandSelectedEvent;
		this.Series.ListaPorMarca(brandSelectedEvent.IdMarca).subscribe(s => this.Global.ListaSeries = s);
	}
}